/* v44 : copie de psm-e-v43.js, seule la ligne f.hidden change (nom neuf : cache du CDN).
   v43 (14/10/2026) : copie de psm-e-v41.js sous un NOM NEUF (cache CDN). Nouvelle grille unique -20/-30/-40/-50 %
   dès 3/5/7/10 paires (hiver et Pilates comptés ensemble), livraison offerte dès 4 articles en France et Zone 1.
   v41 (13/10/2026) : copie de psm-e-v34i.js sous un NOM NEUF (le CDN sert parfois l'ancien contenu d'un asset modifié),
   seule la barre de remise change (palier 8 Pilates -45 %).
   v34 (04/10/2026) : comportements des blocs « façon Elliosa ».
   1. Barre de remise du Mix & Match Pilates : lit le VRAI panier (/cart.js), les packs ne comptent pas (même règle
      que ps-fiche-v2 : titre qui commence par « Pack »), paliers 10/15/20/25 % dès 2/3/4/6 paires. Se relit après
      chaque appel /cart/add|change|update|clear. Se colle en haut quand on a défilé au-delà de sa place.
   2. Compte à rebours vers la VRAIE fin de l'offre (data-pse-fin) : il ne repart jamais à zéro.
   3. Avis repliés : on montre le début, « + » déplie. */
(function () {
  if (window.__pseV34) return; window.__pseV34 = true;

  /* 1. Barre de remise
     v43 (14/10/2026, Nicolas) : une seule grille pour toute la boutique, toutes les paires comptent ensemble (comme
     Shopify, hiver et Pilates, packs exclus) : -20 % dès 3, -30 % dès 5, -40 % dès 7, -50 % dès 10. Le rail fait
     10 paires, repères à 3/10, 5/10, 7/10, le bout à 10. */
  var PALIERS = [[3, 20], [5, 30], [7, 40], [10, 50]];
  function majProg(paires) {
    document.querySelectorAll('[data-pse-prog]').forEach(function (b) {
      var t = b.querySelector('[data-pse-prog-t]'), barre = b.querySelector('[data-pse-prog-barre]');
      var suivant = null, k = 0;
      for (var i = 0; i < PALIERS.length; i++) { if (paires < PALIERS[i][0]) { suivant = PALIERS[i]; k = suivant[0] - paires; break; } }
      if (t) {
        if (!suivant) t.textContent = b.getAttribute('data-max');
        else t.textContent = b.getAttribute(k > 1 ? 'data-pgn' : 'data-pg1').replace('{k}', k).replace('{r}', suivant[1]);
      }
      if (barre) barre.style.transform = 'scaleX(' + Math.min(1, paires / 10).toFixed(3) + ')';
    });
  }
  /* v35 (06/10/2026) : livraison offerte.
     v43 (14/10/2026) : France et Zone 1 = data-art (4) : on compte les ARTICLES du vrai panier (item_count, un coffret
     compte pour 1, comme le minimum de la remise automatique de livraison). Vide : « dès 4 paires » ; en cours :
     « encore N paire(s) » ; atteint : ✓.
     Zone 2 = data-seuil (centimes, EUR), comparé au total du vrai panier (remises comprises) : inchangé. */
  function majFranco(total, articles) {
    document.querySelectorAll('[data-pse-franco]').forEach(function (f) {
      var art = parseInt(f.getAttribute('data-art'), 10) || 0;
      /* v44 (15/10/2026, Nicolas) : la ligne de livraison n'apparaît qu'après la PREMIÈRE paire ajoutée (panier vide :
         rien, pour ne pas décourager). */
      f.hidden = !articles;
      if (art) {
        var ta;
        if (articles >= art) { ta = f.getAttribute('data-ok'); f.setAttribute('data-atteint', '1'); }
        else {
          f.removeAttribute('data-atteint');
          var k = art - articles;
          ta = !articles ? f.getAttribute('data-des') : f.getAttribute(k > 1 ? 'data-resten' : 'data-reste1').replace('{k}', k);
        }
        if (f.textContent !== ta) f.textContent = ta;
        return;
      }
      var seuil = parseInt(f.getAttribute('data-seuil'), 10) || 0;
      if (!seuil) return;
      var txt;
      if (total >= seuil) { txt = f.getAttribute('data-ok'); f.setAttribute('data-atteint', '1'); }
      else {
        f.removeAttribute('data-atteint');
        if (!total) txt = f.getAttribute('data-des');
        else {
          var m; try { m = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR' }).format((seuil - total) / 100); }
          catch (e) { m = ((seuil - total) / 100).toFixed(2).replace('.', ',') + ' €'; }
          txt = f.getAttribute('data-reste').replace('{m}', m);
        }
      }
      if (f.textContent !== txt) f.textContent = txt;
    });
  }
  /* v35 : la ligne du haut dit déjà « livraison offerte » ; sur mobile, le bandeau du panneau du bas (mm-franco) ferait doublon. */
  if (document.querySelector('[data-pse-franco]')) document.documentElement.classList.add('pse-franco-haut');
  /* v35 : 14 taps sans effet en 3 jours sur les paliers (Clarity 04-06/10). Un tap descend jusqu'aux produits. */
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-pse-vers-produits]');
    if (!p) return;
    var cible = document.querySelector('.mix-top-bar') || document.querySelector('.mix-bundle-left') || document.querySelector('[data-mix-match-bundle-main-items]');
    if (!cible) return;
    var prog = document.querySelector('[data-pse-prog]'), tete = document.querySelector('header');
    var dec = (tete ? tete.getBoundingClientRect().height : 0) + (prog ? prog.getBoundingClientRect().height : 0) + 8;
    window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - dec, behavior: 'smooth' });
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-pse-vers-produits]')) { e.preventDefault(); e.target.click(); }
  });
  function lire() {
    if (!document.querySelector('[data-pse-prog]')) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var n = (c.items || []).reduce(function (s, it) { return s + (/^pack\b/i.test(it.product_title || '') ? 0 : it.quantity); }, 0);
        majProg(n);
        majFranco(c.total_price || 0, c.item_count || 0);
      }).catch(function () {});
  }
  var f0 = window.fetch;
  if (f0 && !f0.__pse) {
    var f1 = function (u) {
      var p = f0.apply(this, arguments);
      try { var url = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(lire, 250); }); } catch (e) {}
      return p;
    };
    f1.__pse = true; window.fetch = f1;
  }
  document.addEventListener('cart:updated', lire);

  /* Barre collante : au défilement, dès que son repère (juste sous elle) passe sous le bas de l'en-tête collant du
     thème, elle se fixe sous l'en-tête ; une cale garde sa place pour que la page ne saute pas. */
  var prog = document.querySelector('[data-pse-prog]'), senti = document.querySelector('[data-pse-sentinelle]');
  if (prog && senti) {
    var cale = document.createElement('div'), attente = false; cale.style.display = 'block';
    /* v44 (15/10/2026, Nicolas) : l'en-tête se cache quand on descend et réapparaît quand on remonte. On calcule sa
       position CIBLE (pas celle de l'animation en cours) : caché = 0, visible = son bas sans translation. */
    var tete = document.querySelector('header'); tete = tete && (tete.closest('.shopify-section') || tete);
    var cachee = function () { return document.documentElement.classList.contains('pse-tete-cachee'); };
    var basTete = function () { if (!tete) return 0; if (cachee()) return 0; var r = tete.getBoundingClientRect(), tr = new DOMMatrixReadOnly(getComputedStyle(tete).transform).m42 || 0; return Math.max(0, Math.round(r.bottom - tr)); };
    var dernierY = window.scrollY;
    var sens = function () {
      var y = window.scrollY, h = tete ? tete.offsetHeight : 0;
      if (y > dernierY + 6 && y > h + 40) document.documentElement.classList.add('pse-tete-cachee');
      else if (y < dernierY - 6 || y <= h) document.documentElement.classList.remove('pse-tete-cachee');
      if (Math.abs(y - dernierY) > 6) dernierY = y;
    };
    var caler = function () {
      attente = false;
      var bas = basTete(), fixe = prog.classList.contains('est-fixe');
      var ref = fixe ? cale : senti;
      var limite = fixe ? ref.getBoundingClientRect().top : senti.getBoundingClientRect().top - prog.offsetHeight;
      /* Ordinateur : le bloc « Mon pack » de droite montre déjà les paliers, la barre ne se colle que sur mobile. */
      if (!fixe && window.innerWidth >= 750) { prog.style.top = ''; return; }
      if (!fixe && limite < bas) { cale.style.height = prog.offsetHeight + 'px'; prog.parentNode.insertBefore(cale, prog); prog.classList.add('est-fixe'); }
      else if (fixe && (limite >= bas || window.innerWidth >= 750)) { prog.classList.remove('est-fixe'); if (cale.parentNode) cale.parentNode.removeChild(cale); }
      prog.style.top = prog.classList.contains('est-fixe') ? bas + 'px' : '';
    };
    window.addEventListener('scroll', function () { sens(); if (!attente) { attente = true; requestAnimationFrame(caler); } }, { passive: true });
    caler();
  }

  /* 2. Compte à rebours */
  var fins = document.querySelectorAll('[data-pse-fin]');
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function tic() {
    fins.forEach(function (el) {
      var reste = Math.max(0, Date.parse(el.getAttribute('data-pse-fin')) - Date.now());
      if (isNaN(reste)) { el.textContent = ''; return; }
      var s = Math.floor(reste / 1000), j = Math.floor(s / 86400); s -= j * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600; var m = Math.floor(s / 60); s -= m * 60;
      el.textContent = (j ? j + ' ' + el.getAttribute('data-j') + ' ' : '') + deux(h) + ':' + deux(m) + ':' + deux(s);
    });
  }
  if (fins.length) { tic(); setInterval(tic, 1000); }

  /* 3. Avis repliés */
  document.querySelectorAll('[data-pse-replie]').forEach(function (bloc) {
    var btn = bloc.parentNode.querySelector('[data-pse-deplie]');
    if (bloc.scrollHeight <= 900) { bloc.removeAttribute('data-pse-replie'); return; }
    bloc.setAttribute('data-replie', '');
    if (btn) { btn.hidden = false; btn.addEventListener('click', function () { bloc.removeAttribute('data-replie'); btn.hidden = true; }); }
  });

  /* 4. Fiche Pilates sans bouton « Ajouter » : la taille touchée montre un ✓ bref (l'ajout lui-même est fait par
     ps-fiche-v2). */
  document.querySelectorAll('.psv2[data-famille="pilates"] [data-psv2-variante]').forEach(function (b) {
    b.addEventListener('click', function () { if (b.disabled) return; b.setAttribute('data-pse-ok', ''); setTimeout(function () { b.removeAttribute('data-pse-ok'); }, 1600); });
  });

  lire();
})();
